function truncateString(str, num) {
  if (str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
}

export {
  // eslint-disable-next-line import/prefer-default-export
  truncateString,
};
